import React from "react";
import useCompany from "../hooks/useCompany";

// components
import { CompanyCard } from "../misc/CompanyCard";
import AddBranch from "../misc/AddBranch";
import AddCompany from "../misc/AddCompany";
import GetRCNumber from "../misc/GetRCNumber";

// state
import { join_branch } from "../../../service/api/company";
import { useAppDispatch, useAppSelector } from "../../../store";
import { IJoinCompanyBranch } from "../../../store/@types/company";
import { useNavigate } from "react-router-dom";
import { BranchesList } from "../misc/BranchList";
import { BranchActions } from "../misc/BranchActions";

const Company = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const loading = useAppSelector(({ loading }) => loading.loading);
  const company = useAppSelector(({ company }) => company.company);
  const [id, idSet] = React.useState<string>("");
  const { data, show, showSet, dataSet } = useCompany();

  // console.log("Company Data:", company);

  const [branch, branchSet] = React.useState<IJoinCompanyBranch>({
    branch_id: "",
  });

  const onLoad = React.useCallback(() => {
    if (company) idSet(company?.id);
  }, [company]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const handleBranchSelect = (branchId: string) => {
    branchSet({ branch_id: branch.branch_id === branchId ? "" : branchId });
  };

  const handleRegisterBranch = () => showSet(false);
  const handleJoinBranch = () => join_branch(dispatch, branch, navigate);

  return (
    <div className="w-full max-w-6xl mx-auto mb-12">
      <div className="w-full h-full">
        <div className="grid xl:grid-cols-2 gap-6">
          <div>
            <h3 className="w-full max-w-[35rem] text-xl lg:text-2xl font-bold text-primary-700 mb-2">
              Let us sync you with your company
            </h3>
            <p className="text-gray-500 text-sm lg:text-base">
              This will help us find your company and sync you with it.
            </p>
          </div>
          <div className="w-full">
            <GetRCNumber
              getRCNumber={(res) =>
                dataSet((prev) => ({ ...prev, rc_number: res.rc_number }))
              }
            />
          </div>
        </div>

        {company && show && (
          <div className=" text-dark w-full mt-6">
            <CompanyCard company={company} />

            <BranchesList
              branches={company?.branch}
              selectedBranchId={branch.branch_id}
              onBranchSelect={handleBranchSelect}
            />

            <BranchActions
              onRegisterBranch={handleRegisterBranch}
              onJoinBranch={handleJoinBranch}
              isLoading={loading}
            />
          </div>
        )}

        {!show && id && <AddBranch id={id || ""} />}
        {!company?.id && data.rc_number && (
          <AddCompany rc_number={data.rc_number || ""} />
        )}
      </div>
    </div>
  );
};

export default Company;
